// extracted by mini-css-extract-plugin
export default {"optionsContainer":"c3k8j","optionsContainerDesktop":"bMNh0"};